import apiClient from './client';
import { AuthResponse } from '../types';

export interface LoginPasswordRequest {
  username: string; // Can be email or phone
  password: string;
}

export interface GenerateOtpRequest {
  referenceId: string; // Phone number
  verificationId?: string;
}

export interface LoginOtpRequest {
  referenceId: string; // Phone number
  otp: string;
  countryCode?: string;
}

export const adminAuthService = {
  // Admin Password Login (username can be email or phone)
  loginWithPassword: async (username: string, password: string): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/admins/auth/password/login', {
      username,
      password,
    });
    return response.data;
  },

  // Admin OTP Generation
  generateOtp: async (phone: string, verificationId?: string): Promise<void> => {
    await apiClient.post('/admins/auth/otp/generate', {
      referenceId: phone,
      verificationId,
    });
  },

  // Admin OTP Login
  loginWithOtp: async (loginRequest: LoginOtpRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/admins/auth/otp/login', loginRequest);
    return response.data;
  },
};
